import React from 'react';
import { useReveal } from '../lib/useReveal';
import { ShieldCheckIcon } from '../lib/icons';
export function GuaranteeSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#FCE4EC] py-8 md:py-10 px-5 sm:px-6 border-t border-brand-border-soft" data-id="element-158">
      <div className="container mx-auto max-w-3xl" data-id="element-159">
        <div ref={ref} className={`reveal bg-white border border-brand-border-soft rounded-2xl p-6 md:p-8 text-center shadow-medium relative overflow-hidden ${vis ? 'is-visible' : ''}`} data-id="element-160">
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-primary rounded-full blur-3xl" data-id="element-161"></div>
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-brand-primary rounded-full blur-3xl" data-id="element-162"></div>

          <div className="relative z-10" data-id="element-163">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-primary border border-brand-border-soft mb-6" data-id="element-164">
              <ShieldCheckIcon className="w-8 h-8 text-brand-cta" data-id="element-165" />
            </div>

            <h2 className="text-2xl md:text-4xl font-serif font-bold text-brand-heading mb-6 tracking-wide" data-id="element-166">
              🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="space-y-4 text-lg text-brand-body leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-167">
              <p data-id="element-168">Abrís los tomos. Los usás en tu vida.</p>
              <p data-id="element-169">Si en 7 días no es lo que esperabas, devolución del 100%.</p>
              <p data-id="element-170">Sin formularios. Sin drama. Sin preguntas.</p>
              <p className="text-brand-soft text-sm mt-6 pt-6 border-t border-brand-border-soft" data-id="element-171">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}